// extracted by css-extract-rspack-plugin
export default {"cell-title":"TSsE_s","cellTitle":"TSsE_s"};